/* eslint-disable no-underscore-dangle */
import { createAction } from '@reduxjs/toolkit';
import type { MobilePushOperationState } from '../reducers/mobile-push-operation';
import type { AppThunk } from '../store/configureStore';
import { throwOnError } from './utils';

type PrivateMoney = MobilePushOperationState['private_money'];
// TODO: infer operation type from docs
type MobilePushOperation = Omit<MobilePushOperationState, 'private_money'>;

export const INIT_MOBILE_PUSH_OPERATION = createAction<void>('INIT_MOBILE_PUSH_OPERATION');
export const GET_MOBILE_PUSH_OPERATIONS = createAction<MobilePushOperation>(
  'GET_MOBILE_PUSH_OPERATIONS'
);
export const SELECT_PRIVATE_MONEY_FOR_MOBILE_PUSH_OPERATION = createAction<PrivateMoney>(
  'SELECT_PRIVATE_MONEY_FOR_MOBILE_PUSH_OPERATION'
);

export const initMobilePushOperation = (): AppThunk => (dispatch) =>
  dispatch(INIT_MOBILE_PUSH_OPERATION());

// TODO: anti-pattern, check and fix the functions in this file
export const fetchMobilePushOperation =
  (id: string): AppThunk =>
  () =>
    fetch(`/api/mobile-push-operations/${id}`, {
      method: 'GET',
      credentials: 'same-origin',
    }).then(throwOnError);

export const getMobilePushOperations =
  (query = ''): AppThunk =>
  (dispatch) =>
    fetch(`/api/mobile-push-operations?${query}`, {
      method: 'GET',
      credentials: 'same-origin',
    })
      .then(throwOnError)
      .then((json) => dispatch(GET_MOBILE_PUSH_OPERATIONS(json)));

export const getMobilePushOperationCustomers =
  (id: string, query = ''): AppThunk =>
  () =>
    fetch(`/api/customers?${query}`, {
      method: 'GET',
      credentials: 'same-origin',
    }).then(throwOnError);

export const submitMobilePushOperation =
  (postData: Record<string, unknown> = {}): AppThunk =>
  () =>
    fetch('/api/mobile-push-operations', {
      method: 'POST',
      credentials: 'same-origin',
      headers: {
        'content-type': 'application/json',
      },
      body: JSON.stringify({ _csrf_token: (window as any)._csrf_token, ...postData }),
    }).then(throwOnError);

export const updateDraftMobilePushOperation =
  (id: string, postData: Record<string, unknown> = {}): AppThunk =>
  () =>
    fetch(`/api/mobile-push-operations/${id}`, {
      method: 'PATCH',
      credentials: 'same-origin',
      headers: {
        'content-type': 'application/json',
      },
      body: JSON.stringify({ _csrf_token: (window as any)._csrf_token, ...postData }),
    }).then(throwOnError);

export const cancelMobilePushOperation =
  (id: string): AppThunk =>
  () =>
    fetch(`/api/mobile-push-operations/${id}/cancel`, {
      method: 'POST',
      credentials: 'same-origin',
      headers: {
        'content-type': 'application/json',
      },
      body: JSON.stringify({ _csrf_token: (window as any)._csrf_token }),
    }).then(throwOnError);

export const selectPrivateMoneyForMobilePushOperation =
  (money: PrivateMoney): AppThunk =>
  (dispatch) =>
    dispatch(SELECT_PRIVATE_MONEY_FOR_MOBILE_PUSH_OPERATION(money));

export const getAllMobilePushOperations =
  (query = ''): AppThunk =>
  () =>
    fetch(`/api/all-mobile-push-operations?${query}`, {
      method: 'GET',
      credentials: 'same-origin',
    }).then(throwOnError);

export const approveMobilePushOperation =
  (id: string): AppThunk =>
  () =>
    fetch(`/api/mobile-push-operations/${id}/approve`, {
      method: 'POST',
      credentials: 'same-origin',
      headers: {
        'content-type': 'application/json',
      },
      body: JSON.stringify({ _csrf_token: (window as any)._csrf_token }),
    }).then(throwOnError);

export const rejectMobilePushOperation =
  (id: string): AppThunk =>
  () =>
    fetch(`/api/mobile-push-operations/${id}/reject`, {
      method: 'POST',
      credentials: 'same-origin',
      headers: {
        'content-type': 'application/json',
      },
      body: JSON.stringify({ _csrf_token: (window as any)._csrf_token }),
    }).then(throwOnError);
